import { useAppContext } from '../context/AppContext';
import { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { fetchChartData } from '../services/fetchChartData';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


const ActivityChart = ({ days }) => {
    const { base_url, token } = useAppContext();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const[data, setData] = useState({
        labels: [],
        datasets: []
    });

    useEffect(() => {
        console.log("fetching chart data...");
        if (days === 7) {
            fetchChartData(base_url, token, days, setData, setLoading, setError);
        } else if (days === 30) {
            fetchChartData(base_url, token, days, setData, setLoading, setError);
        }
    }, [base_url, token, days]);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
            position: "top",
            }
        },
        scales: {
            x: {
            title: {
                display: false,
                text: "Date",
            },
            },
            y: {
            title: {
                display: true,
                text: "Count",
            },
            beginAtZero: true,
            },
        },
      };
    

    if(error !== null) {
        return (
            <div id="alert-section" className="chart-content-item alert-section red-alert">
                <h4>Alert</h4>
                <p>{error}</p>
            </div>
        );
    }

    else if(loading === false && !error) {
        return (
            <div className="chart-content-item card">
                <h3>Activity Past {days} Days</h3>
                <hr />
                <Bar data={data} options={options} />
            </div>
        );
    }

    else {
        return (
            <div id="alert-section" className="chart-content-item alert-section yellow-alert">
                <h4>Loading ...</h4>
            </div>
        );
    }
}   

export default ActivityChart;